import { defineMessages } from "@edx/frontend-platform/i18n";

const messages = defineMessages({
  coursesTypesFilterMenuAllCurses: {
    id: "course-authoring.studio-home.courses.tab.types-filter-menu.all-courses",
    defaultMessage: "Todos los cursos",
  },
  coursesTypesFilterMenuActiveCurses: {
    id: "course-authoring.studio-home.courses.tab.types-filter-menu.active-courses",
    defaultMessage: "Activos",
  },
  coursesTypesFilterMenuArchivedCurses: {
    id: "course-authoring.studio-home.courses.tab.types-filter-menu.archived-courses",
    defaultMessage: "Archivados",
  },
});

export default messages;
